// SAMURAI — site content facade.
// Films/prints/brand rosters have been split into ./data/* modules for easier
// future edits. This file keeps the remaining site metadata (brand identity,
// nav, hero media, About copy, team, capabilities, disciplines) and re-exports
// everything so existing imports like `from "../mock"` keep working.

export {
  yt,
  ytFallback,
  LATEST_RELEASES,
  FEATURED,
  WORKS,
  VIRAL_SOCIAL,
} from "./data/films";

export { PRINTS } from "./data/prints";

export {
  BRAND_LOGOS,
  PARTNERS_CLIENTS,
  PARTNERS_AGENCIES,
  PARTNERS,
  MARQUEE_LOGOS,
} from "./data/brands";

export const BRAND = {
  name: "SAMURAI",
  tagline: "Building more room for creativity, craft, storytelling.",
  email: "contact@samur-ai.in",
  locations: "GOA \u00b7 MUMBAI",
  copyright: "\u00a9 2026 Samurai Studios",
};

export const NAV_LINKS = [
  { label: "Work", path: "/work" },
  { label: "Capabilities", path: "/capabilities" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

// Cinematic still bed for the hero (fallback when video is unavailable)
export const HERO_STILLS = [
  "/thumbs/love-beauty-planet.jpg",
  "/thumbs/comfort.jpeg",
  "/thumbs/closeup.jpeg",
  "/thumbs/kissan.png",
];

// Landing page hero video (local, faststart + audio-stripped for max compatibility)
export const HERO_VIDEO = "/videos/hero.mp4";

// Work page header video (behind the "THE WORK." title)
export const WORK_HEADER_VIDEO = "/videos/work-header.mp4";

// Capabilities page hero video
export const CAPABILITIES_HERO_VIDEO = "/videos/capabilities.mp4";

// About page hero video
export const ABOUT_HERO_VIDEO = "/videos/about.mp4";

// Capability preview videos
export const HYBRID_VIDEO = "/videos/hybrid.mp4";
export const AI_LED_VIDEO = "/videos/ai-led.mp4";
export const CONTENT_ENGINE_VIDEO = "/videos/content-engine.mp4";

export const NEWSLETTER_COPY = "Get behind the scenes of every movie.";

// About page copy (client provided)
export const ABOUT_COPY = [
  "We are a collective of filmmakers, artists, producers and technologists who have spent the last three years redefining what filmmaking can become. For us, generative AI is another cinematic tool that expands creative possibility while protecting the integrity of performance, craft and storytelling.",
  "We are no longer bound by physical locations or the limitations of elaborate sets. A Parisian loft in the morning, a futuristic laboratory by afternoon, an endless desert at sunset, all without leaving the studio.",
  "We call it the new language of filmmaking, one where campaigns are no longer limited by geography, logistics or physics, but led purely by imagination.",
];

export const TEAM = [
  { id: "t1", name: "Prafull Sharma", role: "Founding Producer", email: "prafull@samur-ai.in" },
  { id: "t2", name: "Priyanku Sarmah", role: "Creative Head", email: "priyanku@samur-ai.in" },
  { id: "t3", name: "Aditya Pratap", role: "Taisho", email: "taisho@samur-ai.in" },
  { id: "t4", name: "Sadhya Vyas", role: "Executive Producer", email: "sadhya@absoluteproductions.in" },
  { id: "t5", name: "Jigar Joshi", role: "Post Producer", email: "jigar@absoluteproductions.in" },
  { id: "t6", name: "Sameer Bhat", role: "Head of Production", email: "sameer@absoluteproductions.in" },
];

// Capabilities — verbatim from source, hyphens stripped
export const CAPABILITIES = [
  {
    id: "hybrid",
    number: "01",
    title: "Hybrid Production",
    subtitle: "Synchronized live capture & AI creation",
    description:
      "One production pipeline. AI, VFX, and live action working in harmony. Powered by proprietary workflows, we craft cinematic visuals that feel authentic, intentional, and hyperrealistic.",
    video: "/videos/hybrid.mp4",
    image:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  },
  {
    id: "ai",
    number: "02",
    title: "AI-led Production",
    subtitle: "Optimise stills & digital generation",
    description:
      "Fully AI generated from start to finish, AI-led Production delivers fast, scalable content that\u2019s ideal for product films.",
    video: "/videos/ai-led.mp4",
    image:
      "https://images.unsplash.com/photo-1515634928627-2a4e0dae3ddf?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  },
  {
    id: "engines",
    number: "03",
    title: "Content Engines",
    subtitle: "Tailormade for specific marketing needs",
    description:
      "Purpose built creative pipelines that scale effortlessly, delivering high volume, on brand work with uncompromising craft and originality.",
    video: "/videos/content-engine.mp4",
    image:
      "https://images.pexels.com/photos/10395639/pexels-photo-10395639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1400",
  },
];

export const USE_CASES = [
  { id: "uc1", label: "Hybrid, Actors & Dialogues" },
  { id: "uc2", label: "AI Led, Dialogues" },
  { id: "uc3", label: "Content Engine" },
  { id: "uc4", label: "VFX" },
];

export const SOCIAL = [
  { label: "Instagram", href: "https://www.instagram.com/samur_ai.in/" },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/samur-ai-studios/posts/?feedView=all",
  },
  { label: "YouTube", href: "https://www.youtube.com/@Samurai-India" },
];

export const DISCIPLINES = [
  "Direction",
  "DoP",
  "AI / VFX",
  "Editing",
  "Photography",
  "Writing",
  "Sound",
];
